export default __webpack_public_path__ + "static/media/btn_app_Store.3090a337.svg";